import { useLanguage } from '@/context/LanguageContext';

type SwitchProps = {
    isSelected: boolean;
    onSelect: () => void | React.Dispatch<React.SetStateAction<any>>;
};

// https://www.figma.com/design/xnr558XUCXb4vkBy6eAif7/%5B%EB%9D%BC%EC%9D%B4%EB%B8%8C%EB%9F%AC%EB%A6%AC%5D-Potoo-Library?node-id=3006-1617&t=3lunUvpzgaQBTI5S-4
const PageSwitch = (props: SwitchProps) => {
    const { isSelected, onSelect } = props;
    const { t, locale } = useLanguage();

    return (
        <div className="switch-payment" onClick={onSelect}>
            <div
                className={`switch-payment-toggle ${isSelected ? "selected" : ""}`}
            >
                <span className={`switch-payment-label left ${!isSelected ? "switch-active" : ""}`}>
                    {t.header.influencer}
                </span>
                <span className={`switch-payment-label right ${isSelected ? "switch-active" : ""}`}>
                    {t.header.brand}
                </span>
            </div>
        </div>
    );
};

export { PageSwitch };